export default __webpack_public_path__ + "static/media/cant-say-icon.4952cc32.svg";